import { $http } from '@/axios';

function _parameter(active) {
    return $http({ method: 'get', url: 'api/parameter/' + active });
}

const parameter = {
    router: function () {
        return _parameter('Router');
    },
    menu: function () {
        return _parameter('Menu');
    },
    usermenu: function () {
        return _parameter('UserMenu');
    },
    userlanguage: function () {
        return _parameter('UserLanguage');
    },
    group: function () {
        return _parameter('Group');
    },
    sdate: function (date = '') {
        return _parameter('sdate?date=' + date);
    },
    student: function (key = '') {
        return _parameter('student?key=' + key);
    },
    sclass: function (key = '') {
        return _parameter('StudentClass?key=' + key);
    },
    sinfo: function (key = '') {
        return _parameter('StudentInfo?key=' + key);
    },
    emp: function (key = '') {
        return _parameter('emp?key=' + key);
    },
    class: function (ssystemid = '', collegeid = '', departmentid = '', classid = '', key = '') {
        return _parameter('class?ssystemid=' + ssystemid + "&collegeid=" + collegeid + "&departmentid=" + departmentid + "&classid=" + classid + "&key=" + key);
    },
    community: function (key = '') {
        return _parameter('community?property=' + key);
    },
    classcadre: function () {
        return _parameter('Parameter?Type=ClassCadre');
    },
    deduction: function () {
        return _parameter('Parameter?Type=Deduction');
    },
    disadvantaged: function () {
        return _parameter('Parameter?Type=Disadvantaged');
    },
    rent: function () {
        return _parameter('Parameter?Type=Rent');
    },
    house: function () {
        return _parameter('Parameter?Type=House');
    },
    activity: function () {
        return _parameter('Parameter?Type=Activity');
    },
    communityproperty: function () {
        return _parameter('Parameter?Type=CommunityProperty');
    },
    communityjob: function () {
        return _parameter('Parameter?Type=CommunityJob');
    },
    communityactivity: function () {
        return _parameter('Parameter?Type=CommunityActivity');
    },
    injuryplaces: function () {
        return _parameter('Parameter?Type=InjuryPlaces');
    },
    injuryarea: function () {
        return _parameter('Parameter?Type=InjuryArea');
    },
    injuryreason: function () {
        return _parameter('Parameter?Type=InjuryReason');
    },
    injurykind: function () {
        return _parameter('Parameter?Type=InjuryKind');
    },
    injurytreatment: function () {
        return _parameter('Parameter?Type=InjuryTreatment');
    },
};

const pathAuth = function (path = '') {
    return $http({ method: 'get', url: 'api/Identity/PathAuth?path=' + path });
};

export { parameter, pathAuth };